import {apartmentsFeatureKey, apartmentsReducer, ApartmentsState} from '@association/apartments/_store/apartments.reducer';
import {combineReducers} from '@ngrx/store';
import {tenantsFeatureKey, tenantsReducer, TenantsState} from '@association/tenants/_store/tenants.reducer';
import {referenceFeatureKey, referenceReducer, ReferenceState} from "@association/reference/_store/reference.reducer";
import {counterFeatureKey, counterReducer, CounterState} from "@association/counters/_store/counters.reducer";
import {characteristicFeatureKey, characteristicReducer, CharacteristicState} from "@association/characteristics/_store/characteristics.reducer";
import {governmentFeatureKey, governmentReducer, GovernmentState} from "@association/government/_store/government.reducer";
import {userRoleFeatureKey, userRoleReducer, UserRoleState} from "@association/user-roles/_store/user-roles.reducer";
import {apartmentTypesFeatureKey, apartmentTypesReducer, ApartmentTypesState} from '@association/apartments-types/_store/apartment-types.reducer';

export const associationFeatureKey = 'association';

export interface AssociationState {
    [apartmentsFeatureKey]: ApartmentsState,
    [tenantsFeatureKey]: TenantsState,
    [referenceFeatureKey]: ReferenceState,
    [counterFeatureKey]: CounterState,
    [characteristicFeatureKey]: CharacteristicState,
    [governmentFeatureKey]: GovernmentState,
    [userRoleFeatureKey]: UserRoleState
    [apartmentTypesFeatureKey]: ApartmentTypesState
}

export const associationReducers = combineReducers({
    [apartmentsFeatureKey]: apartmentsReducer,
    [tenantsFeatureKey]: tenantsReducer,
    [referenceFeatureKey]: referenceReducer,
    [counterFeatureKey]: counterReducer,
    [characteristicFeatureKey]: characteristicReducer,
    [governmentFeatureKey]: governmentReducer,
    [userRoleFeatureKey]: userRoleReducer,
    [apartmentTypesFeatureKey]: apartmentTypesReducer
});
